"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kebabToCapitalizedConverter = void 0;
const capitalize_1 = require("./capitalize");
const kebabToCapitalizedConverter = (string) => (0, capitalize_1.capitalizeConverter)(string.replace(/-./g, (x) => `${' ' + x.toUpperCase()[1]}`));
exports.kebabToCapitalizedConverter = kebabToCapitalizedConverter;
//# sourceMappingURL=kebabToCapitalized.js.map